export const profile = {
  profileFavoritesIconTitle: 'Избранное',
  profileEditIconTitle: 'Редактировать',
  profileShareIconTitle: 'Поделиться',
  profileAdditionalSectionTitle: 'Дополнительная информация',
  profileFavoritesCurtainTitle: 'Избранное',
  profileFavoriteActionTitle: 'Добавить в избранное',
  profileFavoritedActionTitle: 'Добавлено в избранное',
  profileMessageAction: 'Сообщение',
  profileCurtainAdd: 'Добавить',
  profileReportUser: 'Пожаловаться на пользователя',
  profileReportTitle: 'Пожаловаться',
  profileReportSuccess: 'Контент был пожалован',
  profileReset: 'Сбросить',
  profileApply: 'Применить',
  profileCustomInvalidEmail: 'не является действительным адресом электронной почты',
  profileMaxContentSizeError: 'Вы превысили максимальный размер контента!',
  profileMaxAvatarSizeError: 'Размер вашего аватара слишком велик!',
  profileFavoritesCurtainSearchInputText: 'Поиск',
  profileTapShareCurtainOptionTitle: 'Скопировать',
  profileTapShareLinkCopiedAlertTitle: 'Ссылка скопирована!',
  profileQrShareCurtainTitle: 'Поделиться профилем',
  profileQrShareCurtainShareButtonTitle: 'Поделиться',
  profileQrShareCurtainCopyButtonTitle: 'Скопировать',
  profileQrShareCurtainCopiedAlertTitle: 'Ссылка скопирована!',
  profileQrTapShareProfileCurtainTitle: 'Поделитесь своим профилем',
  profileEditTitle: 'Редактировать',
  profileEditPersonalSectionTitle: 'Персональные данные',
  profileEditContactsSectionTitle: 'Контакты',
  profileEditSocialSectionTitle: 'Социальные сети',
  profileEditAddSocialButtonTitle: 'Добавить социальные сети',
  profileEditAdditionalSectionTitle: 'Дополнительная информация',
  profileEditSaveButtonTitle: 'Сохранить',
  profileEditSavedAlertTitle: 'Профиль сохранен!',
  profileEditEmptyRequiredInputTitle: 'Значение не может быть пустым',
  profileEditEmptyRequiredEmailInputTitle: 'Общий email неверен',
  profileEditEmptyRequiredErrorTitle: 'Что-то пошло не так!',
  profileEditSocialsHint: 'Введите URL вашего социального профиля',
  preferences: 'Предпочтения',
  interestedIn: 'Заинтерессованность в',
  expertIn: 'Я эксперт в',
  myPitch: 'Моя презентация',
  qrBadge: 'QR Badge',
  touchpoints: 'Touchpoints',
  lookingFor: 'Я ищу',
  topicsToDiscuss: 'Темы для обсуждения',
  createNew: 'Создать',
  viewTopic: 'Просмотреть',
  hobbyInterests: 'Хобби и интересы',
  myNetwork: 'Моя сеть',
  seeAll: 'Посмотреть все',
  checkThemOut: 'Посмотрите!',
  activities: 'Деятельности',
  oneOnOne: '1:1 Встреча',
  Leaderboard: 'Таблица лидеров',
  learnNetworking: 'Узнать больше о Networking Hub',
  networkingGroup: 'Группа для сетевого взаимодействия',
  networkingLevel: 'Уровень сетевого взаимодействия',
  addNote: 'Добавить заметку',
  notes: 'Заметки',
  enterNote: 'Введите заметку',
  shareUserProfile: 'Поделиться профилем пользователя',
  flagUser: 'Пожаловаться на пользователя'
}
